// src/components/fix-actions/template-icons.ts
import type { LucideIcon } from "lucide-react";
import {
  Sparkles,
  FileText,
  Table,
  HelpCircle,
  Code2,
  ListChecks,
  ClipboardList,
  BarChart3,
  Database,
  LayoutTemplate,
} from "lucide-react";

/**
 * Map backend `iconKey` values -> Lucide icon components.
 * Add keys as your backend grows.
 */
export const TEMPLATE_ICON_MAP: Record<string, LucideIcon> = {
  schema: Code2,
  structured_data: Code2,
  faq: HelpCircle,
  content: FileText,
  copy: FileText,
  checklist: ListChecks,
  framework: ClipboardList,
  comparison: Table,
  data: Database,
  analytics: BarChart3,
};

export const DEFAULT_TEMPLATE_ICON: LucideIcon = LayoutTemplate;
export const FALLBACK_TEMPLATE_ICON: LucideIcon = Sparkles;
